<template lang="pug">
  .bcard-pagination.text-center(:class="{vhidden: !isLoading || movingPage}")
    div: slot(name="left")
    ul.pagination(:class="{vhidden: !pagination.page_count || pagination.page_count === 1}")
      li(title="最初へ", :class="{disabled: !pagination.has_prev_page}")
        a(href='#' @click.prevent="gotoFirst") «
      li(title="前へ", :class="{disabled: !pagination.has_prev_page}")
        a(href='#' @click.prevent="gotoPrev") ‹
      li(v-for="i in pages", :class="{active: isActive(i)}")
        a(href='#' @click.prevent="gotoPage(i)") {{i}}
      li(title="次へ", :class="{disabled: !pagination.has_next_page}")
        a(href='#' @click.prevent="gotoNext") ›
      li(title="最後へ", :class="{disabled: !pagination.has_next_page}")
        a(href='#' @click.prevent="gotoLast") »
    .bcard-pagination-count 全 {{pagination.count || 0}} 件
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    isLoading: {type: Boolean, required: false, default: true},
    pagination: {type: Object, required: true}, // APIから返ってきたpaginationをそのまま渡すこと
    range: {type: Number, default: 3}, // ページ番号のmaxリンク数（奇数）
    useScrollTop: {type: Boolean, required: false, default: true} // ページがえのときにtopに移動するフラグ
  },
  data: function () {
    return {
      movingPage: false
    }
  },
  computed: {
    pages: function () {
      let pages = []
      let p = this.pagination
      let r = this.range

      for (let i = 1; i <= p.page_count; i++) {
        pages.push(i)
      }

      r = Math.floor(r / 2) * 2 + 1

      if (r >= 1) {
        pages = pages.splice(
          Math.max(
            0,
            Math.min(
              pages.length - r,
              p.current_page - Math.ceil(r / 2)
            )
          ),
          r
        )
      }

      return pages
    }
  },
  watch: {
    isLoading: function (newValue, oldValue) {
      if (!newValue && oldValue) {
        this.movingPage = false
      }
    }
  },
  methods: {
    isActive: function (pageNo) {
      return pageNo === this.pagination.current_page
    },
    gotoPage: function (pageNo) {
      this.movingPage = true
      this.$emit('change', {
        page: pageNo,
        viaPagination: true
      })
      if (this.useScrollTop) {
        this.scrollToTop()
      }
      // 表示順変更中でなければ前のページのチェックボックスを解除する
      if (!this.$store.getState('isListSortMode')) {
        this.$parent.checkedIds = []
      }
    },
    gotoFirst: function () {
      if (this.pagination.has_prev_page) {
        this.gotoPage(1)
      }
    },
    gotoPrev: function () {
      if (this.pagination.has_prev_page) {
        this.gotoPage(this.pagination.current_page - 1)
      }
    },
    gotoNext: function () {
      if (this.pagination.has_next_page) {
        this.gotoPage(this.pagination.current_page + 1)
      }
    },
    gotoLast: function () {
      if (this.pagination.has_next_page) {
        this.gotoPage(this.pagination.page_count)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bcard-pagination {
  // ページ番号は中央、件数は右端に置く
  display:flex;
  align-items: center;
  justify-content: space-between;

  .pagination {
    margin: 0;

    &.vhidden {
      visibility: hidden;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/AppPagination.vue